import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6849fd64&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6849fd64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6849fd64')) {
      api.createRecord('6849fd64', component.options)
    } else {
      api.reload('6849fd64', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6849fd64&scoped=true", function () {
      api.rerender('6849fd64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/userSetting/account/index.vue"
export default component.exports